import React from 'react';
import Link from 'next/link';
import { Form, Formik } from 'formik';
import { PaymentMethodSection } from '../PaymentMethodSection';
import InvoiceTable from '@components/InvoiceTable';
import {
  authenticatedCheckoutSchema,
  unAuthenticatedCheckoutSchema
} from '@lib/schemas';
import { SubscriptionState } from 'types/subscription';
import { getCurrencySymbol } from '@lib/page-utils/Join';

interface SubscriptionFormProps {
  subscriptionState: SubscriptionState;
  isAuthenticated: boolean;
  pending: boolean;
  error: string;
  onSubmit: () => Promise<void>;
}

export const SubscriptionForm: React.FC<SubscriptionFormProps> = ({
  subscriptionState,
  isAuthenticated,
  pending,
  error,
  onSubmit
}) => {
  const term = subscriptionState.term === 'years' ? 'Year' : 'Month';
  const hasCreditBalance =
    subscriptionState.total !== undefined &&
    typeof subscriptionState.total === 'number' &&
    subscriptionState.total < 0;
  const firstInvoiceLine = subscriptionState?.invoiceLines?.[0];
  const currencyCode = firstInvoiceLine?.currency || 'gbp';
  const currencySymbol = getCurrencySymbol(currencyCode);

  return (
    <div className="space-y-6">
      <p>
        Term: {currencySymbol}
        {subscriptionState.newSubscriptionPrice} / {'Year'}
        <Link href="/join" className="text-xs link">
          change plan
        </Link>
      </p>

      <Formik
        initialValues={{ terms: [] }}
        validationSchema={
          isAuthenticated
            ? authenticatedCheckoutSchema
            : unAuthenticatedCheckoutSchema
        }
        onSubmit={async (values, actions) => {
          actions.setSubmitting(false);
          await onSubmit();
        }}
      >
        {({ isSubmitting }) => (
          <Form className="ffh-form" data-rewardful="false">
            <hr />
            <InvoiceTable
              term={term}
              newSubscriptionPrice={subscriptionState.newSubscriptionPrice}
              invoiceLines={subscriptionState.invoiceLines}
              invoiceTotal={subscriptionState.total}
              hasCreditBalance={hasCreditBalance}
              currencySymbol={currencySymbol}
            />
            <hr />
            <PaymentMethodSection
              price={subscriptionState.newSubscriptionPrice}
              isSubmitting={isSubmitting}
              isAuthenticated={isAuthenticated}
              pending={pending}
              error={error}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};
